/* src/app/main/help/help.component.scss */
.tipps p {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  font-size: medium;
}
/*# sourceMappingURL=help.component.css.map */
